import LoginComponent from "../../components/auth/login"

const Login = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  )
}

export default Login
